import TopBar from './components/TopBar';
import FocusSection from './components/FocusSection';
import ScreenshotSection from './components/ScreenshotSection';
import ChatSection from './components/ChatSection';
import VideoSection from './components/VideoSection';
import FileSection from './components/FileSection';
import IndexSection from './components/IndexSection';
import LogSection from './components/LogSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-800">
      <TopBar />
      <main>
        <FocusSection />
        <ScreenshotSection />
        <ChatSection />
        <VideoSection />
        <FileSection />
        <IndexSection />
        <LogSection />
      </main>
      <SiteFooter />
    </div>
  );
}